import styled from 'styled-components'
import { BqSelect } from '@beeq/react'

export const PageSizeWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: var(--bq-spacing-xs);
`

export const PaginationSelect = styled(BqSelect)`
  max-width: 140px;
  min-width: 140px;
`
